import { render } from "./ApplyWithDrawDeposit.vue?vue&type=template&id=4a638752&scoped=true&ts=true"
import script from "./ApplyWithDrawDeposit.vue?vue&type=script&lang=ts"
export * from "./ApplyWithDrawDeposit.vue?vue&type=script&lang=ts"

import "./ApplyWithDrawDeposit.vue?vue&type=style&index=0&id=4a638752&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a638752"]])

export default __exports__